export default {
  EquipmentIndex: {
    pageTitle: 'Homepage ',
    name: 'Car A/C cleaning, recycling and recharging machine',
    desc1: 'S/N',
    desc2: 'Model ',
    item1: 'User Manual',
    item2: ' Operation Manual',
    item3: 'Quick start',
    item4: 'After-sale service policies',
    item5: 'Questions or comments for the device',
    desc3: 'Good comments will be rewarded'
  },
  EquipmentSuggestion: {
    pageTitle: 'Questions or comments for the device',
    placeholder1: 'Please describe your questions or comments so that we can provide better assistance',
    errorMsg1: 'The entered text is too long',
    errorMsg2: 'Questions or comments cannot be empty',
    title1: 'Upload picture',
    title2: 'Contact information',
    errorMsg3: 'Contact information cannot be empty',
    errorMsg4: 'Format of contact information is not correct',
    placeholder2: 'Please fill in your mobile phone number',
    placeholder3: 'Please fill in your email address',
    button1: 'Submit anonymously',
    tips: 'If the submitted comment is adopted, you may be rewarded.',
    tips2: 'You will have a chance to get rewards if you leave the contact information.',
    button2: 'Submit the comment',
    msg: 'Submitted successfully'
  },
  EquipmentSpecification: {
    pageTitle: 'User Manual'
  },
  EquipmentManual: {
    pageTitle: 'Operation Manual'
  },
  EquipmentQuickStart: {
    pageTitle: 'Quick start'
  },
  EquipmentASSPolicy: {
    pageTitle: 'After-sale service policies'
  },
  MyReward: {
    pageTitle: 'My rewards',
    button1: 'Withdraw',
    title: 'My balance',
    summary1: 'Submit the comment',
    summary2: 'Adopted',
    summary3: 'Accumulated rewards',
    item1: 'Income details',
    item2: 'Withdrawal account',
    view: 'View'
  },
  MyRewardList: {
    pageTitle: 'My rewards',
    type1: 'Withdraw',
    type2: 'Reward for adoption of suggestions',
    status1: 'Successful',
    status2: 'Failed',
    status3: 'In progress',
    noMore: 'No more data'
  },
  MyRewardDetail: {
    pageTitle: 'Details',
    name: 'Withdraw',
    item1: 'Type',
    item2: 'Time',
    item3: 'Status',
    item4: 'Cause of failure'
  },
  Account: {
    pageTitle: 'Account',
    title1: 'Alipay account',
    title2: 'PayPal account',
    placeholder1: 'Enter the name (for transfer verification)',
    errorMsg1: 'The username cannot be null',
    errorMsg2: 'The username is incorrect',
    placeholder2: 'Enter Alipay account',
    placeholder3: 'Enter PayPal account',
    errorMsg3: 'The account cannot be null',
    errorMsg4: 'The account is incorrect',
    button: 'OK',
    msg1: 'Success'
  },
  Withdraw: {
    pageTitle: 'Withdraw',
    title: 'withdrawal amount',
    placeholder: 'Please enter the withdrawal amount',
    desc1: 'Withdrawable amount ',
    desc2: 'Withdraw all',
    item1: ' Receiving account',
    button: 'OK',
    errorMsg1: 'The amount cannot be null',
    errorMsg2: 'The amount entered is illegal',
    errorMsg3: 'Insufficient balance',
    msg: 'Success',
    msg2: 'Notice',
    msg3: 'Are you sure?'
  },
  WithdrawStatus: {
    pageTitle: 'Withdraw ',
    status1: 'Cash withdrawal application',
    status2: 'In processing',
    status3: 'Arrival account',
    button: 'Completed'
  },
  Captcha: {
    title: 'Enter the verification code',
    desc1: 'Verification code has been sent to',
    desc2: 'Resend',
    desc3: 'Resend 60s later',
    errorMsg: 'Verification code incorrect',
    msg1: 'Send successfully',
    msg2: 'Verification code error'
  },
  Download: {
    pageTitle: 'Download',
    name: 'Launch device code',
    desc1: 'Device code APP is a mobile client that provides users with convenient and fast access to device information, submitted suggestions and use of shared auto repair equipment services',
    desc2: 'If the suggestion you submitted is adopted, you will receive a reward. Please download and use it！',
    button: 'Download now'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js